/*
 * Groups Messages
 *
 * This contains all the text for the Groups container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.Groups';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Groups',
  },
  groupsTotal: {
    id: `${scope}.groupsTotal`,
    defaultMessage: 'groups total',
  },
  addGroup: {
    id: `${scope}.addGroup`,
    defaultMessage: 'Add group',
  },
  editGroup: {
    id: `${scope}.editGroup`,
    defaultMessage: 'Edit group',
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Search',
  },
  group: {
    id: `${scope}.group`,
    defaultMessage: 'Group',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  createAccessCode: {
    id: `${scope}.createAccessCode`,
    defaultMessage: 'Create Access Code',
  },
  sendQuestion: {
    id: `${scope}.sendQuestion`,
    defaultMessage: 'Send Questionnaire',
  },
  groupsLimit: {
    id: `${scope}.groupsLimit`,
    defaultMessage: 'Groups limit reached, upgrade your subscription plan.',
  },
});
